import {
    pxToRem,
    pxArrayToRem,
    paginationItemsPerPageSlotClassNames,
    dropdownSlotClassNames,
    paginationItemClassName,
    paginationSlotClassNames,
} from '@archipro-design/aria';

import type { StyleRule } from '@archipro-design/aria';

export const VideoSection: StyleRule = () => ({});

export const Header: StyleRule = () => ({
    [`& > div`]: {
        padding: pxArrayToRem([0, 36]),
    },
});

export const Container: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        marginBottom: 0,
    },
});

export const ResultSection: StyleRule = ({ theme }) => ({
    [`& > div`]: {
        padding: 0,

        [theme.screen.laptop]: {
            margin: pxArrayToRem([0, -14]),
        },
    },
});

export const PaginationWrapper: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18]),
    [`& .${paginationItemsPerPageSlotClassNames.dropdown}`]: {
        ':hover': {
            backgroundColor:
                theme.siteVariables.colors.transparency.white['10%'],
        },
    },

    [`& .${paginationSlotClassNames.divider}`]: {
        display: 'none',
    },

    [`& .${paginationSlotClassNames.paginationMetaData}`]: {
        [`&> *:not(:last-child)`]: {
            margin: 0,
        },
    },

    [`& .${dropdownSlotClassNames.selectedItems}`]: {
        color: theme.siteVariables.colors.primitive.white,
    },

    [`& .${dropdownSlotClassNames.toggleIndicator}`]: {
        fill: theme.siteVariables.colors.primitive.white,
    },

    [theme.screen.tablet]: {
        paddingTop: pxToRem(120),
    },
});

export const DesktopFilterGroup: StyleRule = () => ({
    gap: pxToRem(33),
    marginTop: pxToRem(7.5),
    alignItems: 'flex-start',
});

export const FilterBar: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([17, 8, 16]),
    borderBottom: `1px solid ${theme.siteVariables.colors.transparency.white['30%']}`,

    [theme.screen.laptop]: {
        padding: pxArrayToRem([10, 0, 0]),
        marginTop: pxToRem(2),
        marginBottom: 0,
        borderBottom: 'none',
        justifyContent: 'flex-end',
    },
});

export const PaginationMobile: StyleRule = () => ({
    width: '100%',
    [`& .${paginationItemClassName}`]: {
        display: 'flex',
    },
});
